import React from 'react';

const FormError = ({ text, className }) => (
  <div className={`text-danger g text__fs-10 ${className ?? ''}`}>{text}</div>
);

export default FormError;
